import $ from 'jquery'
import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import { Actions, Getters } from '../../store/editor/components/helpers'
import { GerberaContent, GerberaHeader } from '../../store/editor/components/state'
import { MAX_TITLE_LENGTH, RECOMMENDED_TITLE_LENGTH } from '../constants/TitleLength'
import moment, { Moment } from 'moment'
import { Watch } from 'vue-property-decorator'
import { INITIAL_COLOR, PREDEFINE_COLORS } from '../constants/ColorPicker'

moment.locale('ja')

@Component
export default class HeaderSectionVue extends Vue {
  $store: Store<RootState>
  hasFocus: boolean = false
  readonly maxLength = MAX_TITLE_LENGTH
  readonly recommendedLength = RECOMMENDED_TITLE_LENGTH
  title: string = ''
  onResizeWindow: () => void
  backgroundColor: string = INITIAL_COLOR
  predefineColors: string[] = PREDEFINE_COLORS
  clickedColorPicker: boolean = false

  get contentData(): GerberaContent {
    return Getters.gerberaContent(this.$store)
  }

  get headerData(): GerberaHeader {
    return Getters.headerSectionContent(this.$store)
  }

  get color(): string | undefined {
    const header = this.headerData
    return (header && header.background) ? header.background.color : undefined
  }

  get originalTitle(): string {
    return this.removeLineSeparator(this.contentData.title || '')
  }

  set originalTitle(title: string) {
    const article = Object.assign({}, this.contentData, <GerberaContent>{
      title: this.removeLineSeparator(title)
    })
    Actions.updateGerberaContent(this.$store, article)
  }

  get noTitle(): boolean {
    return !this.title
  }

  get hasInvalidLength(): boolean {
    return !!this.title && this.title.length > this.maxLength
  }

  get hasAlertLength(): boolean {
    return !!this.title && this.title.length > this.recommendedLength
  }

  get hasWarning(): boolean {
    return this.noTitle || this.hasInvalidLength
  }

  get publishDate(): string {
    const publishDate = this.toMoment(this.contentData.publishedDate)
    const displayDate = this.isEffectiveDate(publishDate) ? publishDate : undefined
    return displayDate ? displayDate.format('YYYY-MM-DD HH:mm') : 'ここには記事の公開日時が表示されます'
  }

  mounted(): void {
    this.initBackgroundColor()
    this.loadTitle()
    this.autoResizeTitle()
    this.onResizeWindow = () => {
      this.autoResizeTitle()
    }
    window.addEventListener('resize', this.onResizeWindow)
  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.onResizeWindow)
  }

  toMoment(date: string | undefined): Moment | undefined {
    if (!date) {
      return undefined
    }
    return moment(date)
  }

  isEffectiveDate(date: Moment | undefined): boolean {
    return !!date && date.get('year') > 1900
  }

  @Watch('originalTitle')
  loadTitle(): void {
    Vue.set(this, 'title', this.originalTitle)
  }

  @Watch('title')
  autoResizeTitle(): void {
    // テキストがHTMLに反映されてからサイズを計算したいので、 nextTick 内で処理する
    this.$nextTick(() => {
      const title = $(this.$el).find('.header-section__title').get(0)
      title.style.cssText = 'height: 0;'
      const borderHeight = title.offsetHeight - title.clientHeight
      const contentHeight = title.scrollHeight + borderHeight
      title.style.cssText = 'height: ' + contentHeight + 'px'
    })
  }

  onFocusTitle(event: FocusEvent): void {
    this.autoResizeTitle()
    this.hasFocus = true
  }

  onBlurTitle(event: FocusEvent): void {
    this.saveTitle()
    this.autoResizeTitle()
    this.hasFocus = false
    this.trackTitle()
  }

  onKeyDownTitle(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      event.preventDefault()
    }
  }

  removeLineSeparator(text: string): string {
    return text.replace(/\r?\n/g, '')
  }

  trackTitle(): void {
  }

  saveTitle(): void {
    this.originalTitle = this.title
  }

  activeColor(val: string): void {
    this.backgroundColor = val
  }

  @Watch('color')
  initBackgroundColor(): void {
    this.backgroundColor = this.color ? this.color : INITIAL_COLOR
  }

  clickedColorPickerIcon(): void {
    this.clickedColorPicker = true
  }

  submitColor(color: string): void {
    this.saveColor(color)
    this.clickedColorPicker = false
  }

  // カラーピッカーが閉じたときの処理
  closeColorPicker(): void {
    if (!this.clickedColorPicker) {
      return
    }
    this.clickedColorPicker = false
    this.saveColor(this.backgroundColor)
  }

  saveColor(color: string): void {
    if (!color) {
      color = INITIAL_COLOR
      this.backgroundColor = INITIAL_COLOR
    }
    this.$nextTick(() => {
      const header = Object.assign({}, this.headerData, <GerberaHeader>{
        background: {
          color
        }
      })
      Actions.updateHeaderSectionContent(this.$store, header)
    })
  }
}
